// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { usePendingIncomingPayment, getNequiExpirationDatetime } from '@tectonics/prs/incoming-payment';
import { formatDueDate } from '@tectonics/prs/nequi';

export function TicketDue(): Node {
  const expirationDateTime = getNequiExpirationDatetime(usePendingIncomingPayment());

  return (
    <Root>
      <Term>Fecha y hora de expiración</Term>
      <Definition>{formatDueDate(expirationDateTime)}</Definition>
      <AdditionalText>Paga hasta {getWeekDay(expirationDateTime, dueDateWeekDay)}</AdditionalText>
    </Root>
  );
}

const Root = styled.dl`
  text-align: center;
  padding: 1.2em;
`;

const Term = styled.dt`
  font-family: ${props => props.theme.fontFamily.sansSerif};
  font-size: 0.9em;
`;

const Definition = styled.dd`
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.3em;
  font-weight: bold;
`;

const AdditionalText = styled.dd`
  color: ${props => props.theme.colors.secondary(20)};
  background-color: ${props => props.theme.colors.info(96)};
  font-size: 0.9em;
  border-radius: 0.2em;
  width: fit-content;
  padding: 0 1em;
  margin: 0 auto;
`;

const dueDateWeekDay = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
];

function getWeekDay (stringDate: string, weekDaysTemplate: ImmutableArray<string>): string {
  const date = new Date(stringDate);

  const weekDay = date.getDay();

  return weekDaysTemplate[weekDay];
}
